import React from 'react';
import Input from 'src/components/Input';
import './CustomRoomForm.scss';
import CalloutCard from 'src/components/CalloutCard/CalloutCard';
import { variables } from 'src/Tenants';

interface Props {
  value: string;
  onChange: (val: string) => void;
}

const CustomRoomForm: React.FC<Props> = ({ value, onChange }) => (
  <div className="custom_form_container">
    <div className="input_group">
      <Input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        label="Room Name"
        placeholder="e.g. Wine Cellar, Home Office, Server Room"
        block
        required
      />
      <div className="char_counter">{value.length} / 100</div>
    </div>
    <CalloutCard
      icon_type="info"
      message={`Custom rooms are unique to this ${variables.suite} and won't appear in the preconfigured room list for other units. Use this for non-standard spaces like wine cellars, home offices, or server rooms.`}
    />
  </div>
);

export default CustomRoomForm;
